import React from 'react';
import glamorous from 'glamorous';

import CuratedInfoBlock from './CuratedInfoBlock';
import DeliveryOptions from './DeliveryOptions';

const Container = glamorous.div(props => ({
  borderBottom: '1px solid rgb(230, 230, 230)',
  borderLeftWidth: 5,
  borderLeftStyle: 'solid',
  borderLeftColor: props.borderLeftColor,

  cursor: 'pointer',

  '&:hover': {
    backgroundColor: '#f9f9f9',
  },
}));

const styleEventRow = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 55,
};

const EventRow = ({borderLeftColor, ...props}) => (
  <div style={styleEventRow} {...props}>
    {props.children}
  </div>
);

const EventRowInfo = glamorous.div({
  paddingLeft: 12,
});

const EventTitle = glamorous.div({
  fontWeight: 'bold',
  color: 'rgb(37, 37, 37)',
});

const EventSubtitle = glamorous.div({
  color: 'rgb(142, 142, 147)',
});

const EventRowPrice = glamorous.div({
  textAlign: 'right',
  paddingRight: 8,
});

const TicketListRow = (props) => {
  const { ticket } = props;

  return (
    <Container
      id={`tgid${ticket.tgID}`}
      tgid={ticket.tgID}
      borderLeftColor={ticket.tgColor || '#e0e0e0'}>
      <EventRow>
        <EventRowInfo>
          <EventTitle>
            {ticket.getSectionDisplayName()}
          </EventTitle>
          <EventSubtitle>
            Row {ticket.getRowDisplayName()} &bull; {ticket.tgQty} Tickets
            {ticket.tg}
            <DeliveryOptions
              isIconOnly
              {...ticket.tgClientData}
            />
          </EventSubtitle>
        </EventRowInfo>

        <EventRowPrice>
          <strong>${ticket.tgPrice}</strong>/ea
          <span className="cm-right-arrow" />
        </EventRowPrice>
      </EventRow>

      {props.hasTicketAttributes && ticket.tgClientData && (
        <CuratedInfoBlock ticket={ticket} />
      )}
    </Container>
  );
};

export default TicketListRow;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/TicketListRow.js